<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t('Not found this page') }}
          </v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="margin-left: -93px;text-align: center;margin-top: -95px;">
            <img
              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
              alt="empty shopping cart"
              style="width: 140px;padding-bottom: 10px;"
            >
            <p style="padding-bottom: 10px">{{$t('There are no items in this cart')}}</p>
            <v-btn
              outline
              :color="theme.color"
              @click="goToShop()"
            >{{$t('Continue Shopping')}}</v-btn>
          </div>
        </cover>
      </div>-->
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="pageLoading" style="height: 100vh">
        <v-layout justify-center align-center style="height: 100%">
          <v-progress-circular
            :key="theme.color"
            :size="70"
            :width="7"
            :color="theme.color"
            indeterminate
          ></v-progress-circular>
        </v-layout>
      </div>-->
      <div v-else>
        <merchant-detail v-model="pageProfile"></merchant-detail>

        <form
          id="checkout-form"
          class="checkout-form"
          method="POST"
          @submit.prevent="handleSubmit"
        >
          <v-container class="mt-5">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline" :style="{ color: theme.color }">
                  {{ $t('Payment') }}
                </h3>

                <br />
              </v-flex>
              <v-flex xs12 sm6 offset-sm3>
                <div
                  :class="{ 'has-error': errors.has('customerName') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Name')"
                    :data-vv-as="$t('Name')"
                    outline
                    name="customerName"
                    v-validate="'required'"
                    v-model="customerName"
                    light
                    :color="theme.color"
                    :error="errors.has('customerName') ? true : false"
                    :error-messages="
                      errors.has('customerName')
                        ? errors.first('customerName')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <v-layout>
                  <v-flex class="pa-1">
                    <v-btn
                      :color="
                        chooseShippingType == 'delivery' ? theme.color : 'grey'
                      "
                      depressed
                      :outline="chooseShippingType != 'delivery'"
                      block
                      dark
                      @click="chooseShippingType = 'delivery'"
                    >
                      จัดส่งสินค้า
                    </v-btn>
                  </v-flex>
                  <v-flex class="pa-1">
                    <v-btn
                      :color="
                        chooseShippingType == 'pickup' ? theme.color : 'grey'
                      "
                      depressed
                      :outline="chooseShippingType != 'pickup'"
                      block
                      dark
                      @click="chooseShippingType = 'pickup'"
                    >
                      รับที่ร้าน
                    </v-btn>
                  </v-flex>
                </v-layout>
                <template v-if="chooseShippingType == 'delivery'">
                  <div
                    :class="{ 'has-error': errors.has('shippingAddress') }"
                    class="mb-1"
                  >
                    <div class="mb-3">
                      <div
                        :class="{ 'has-error': errors.has('ปักหมุดที่อยู่') }"
                        class="mb-1"
                      >
                        <gmap-address
                          v-if="showmap"
                          :placesinfo="placesinfolabel"
                          v-validate="{ required: true }"
                          name="ปักหมุดที่อยู่"
                          v-model="gmapvalue"
                          v-on:input="gmapLocation"
                          :lastordercoords="lastordercoords"
                          :error="errors.has('ปักหมุดที่อยู่')"
                          :shoplocation="branchlocation"
                          :radius="40000"
                          :radiusColor="theme.color"
                          :infoloading="false"
                        ></gmap-address>
                        <p
                          class="caption ma-2"
                          style="color: red"
                          v-show="errors.has('ปักหมุดที่อยู่')"
                        >
                          {{ errors.first('ปักหมุดที่อยู่') }}
                        </p>
                      </div>
                    </div>
                    <v-textarea
                      outline
                      :label="$t('Shipping Address')"
                      :placeholder="
                        $t('Ex. Address No., Village, Alley, and Road')
                      "
                      name="shippingAddress"
                      rows="5"
                      :data-vv-as="$t('Shipping Address')"
                      style="resize: none; width: 100%"
                      v-model="shippingAddress"
                      readonly
                      v-validate="{
                        required: true,
                        regex: /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                        isBearhousezipcode: [cart.length, isBearhouse]
                      }"
                      light
                      :color="theme.color"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress')
                          ? errors.first('shippingAddress')
                          : ''
                      "
                    ></v-textarea>
                  </div>
                </template>
                <template v-else>
                  <div
                    :class="{ 'has-error': errors.has('shippingAddress') }"
                    class="mb-3"
                  >
                    <v-radio-group
                      name="shippingAddress"
                      :data-vv-as="$t('Shipping Address')"
                      v-model="pickuplocation"
                      class="full-width"
                      style="width: 100%"
                      v-validate="{
                        required: true
                      }"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress')
                          ? errors.first('shippingAddress')
                          : ''
                      "
                    >
                      <v-card class="mb-2">
                        <v-card-text>
                          <v-layout>
                            <v-radio
                              :value="`รับสินค้าที่ สาขา 1 ร้านเพียวไลท์ (รามอินทรา)`"
                              :color="theme.color"
                            ></v-radio>
                            <v-flex>
                              <span class="pl-3">
                                สาขา 1 ร้านเพียวไลท์ (รามอินทรา) ทุกวัน 08.00 -
                                18.00 น. (กรุณาระบุเวลารับสินค้าในช่องหมายเหตุ)
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-radio-group>
                  </div>
                </template>

                <div
                  :class="{ 'has-error': errors.has('customerPhone') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Tel.')"
                    :data-vv-as="$t('Tel.')"
                    outline
                    tyle="tel"
                    name="customerPhone"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      regex: /(\d{10})/
                    }"
                    :mask="'##########'"
                    v-model="customerPhone"
                    :error="errors.has('customerPhone') ? true : false"
                    :error-messages="
                      errors.has('customerPhone')
                        ? errors.first('customerPhone')
                        : ''
                    "
                  ></v-text-field>
                </div>

                <template
                  v-if="
                    pageProfile && pageProfile.pageid && shippinglist && !isOoca
                  "
                >
                  <shipping-type
                    v-show="false"
                    :bearhouseshippingprice="bearhouseshippingprice"
                    :khaiwhanshippingprice="khaiwhanshippingprice"
                    v-model="shippingType"
                    :shippinglist="shippinglist"
                    :additionalproduct_charge="additionalproduct_charge"
                    :pageid="pageProfile.pageid"
                    :total="totalincludediscount"
                  ></shipping-type>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="mt-3">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline mb-3" :style="{ color: theme.color }">
                  {{ $t('Payment Detail') }}
                </h3>
                <cart-summary
                  :khaiwhanshippingprice="khaiwhanshippingprice"
                  :bearhouseshippingprice="bearhouseshippingprice"
                  :total="total"
                  :totalincludediscount="
                    totalPrice -
                    (this.customshippingprice || 0) -
                    (this.additionalproduct_charge || 0)
                  "
                  :discount="discount"
                  :voucher="voucher"
                  :shippingType="shippingType"
                  :additionalproduct_charge="additionalproduct_charge"
                  :customerShippingPrice="customshippingprice"
                  :isCustomize="true"
                  :ableToBuy="ableToBuy"
                ></cart-summary>
                <div
                  v-if="
                    !(pageProfile.fbpay_status || pageProfile.gbprime_status)
                  "
                >
                  <div class="mb-4">
                    <template v-if="banktransferinfo_photo">
                      <img
                        :src="banktransferinfo_photo"
                        alt="bank transfer"
                        style="
                          border: 1px solid #eee;
                          border-radius: 5px;
                          margin-bottom: 15px;
                          width: 100%;
                        "
                      />
                    </template>
                    <template v-if="banktransferinfo">
                      <bank-number :text="banktransferinfo"></bank-number>
                    </template>
                    <!-- <bank-number
                      :text="
                        `กรุณาโอนเงินมาที่\nธนาคาร: ${
                          khaiwhanselectedbank.bankname
                        } \nเลขที่บัญชี: ${
                          khaiwhanselectedbank.banknum
                        } <<กดตรงนี้เพื่อ copy\nชื่อบัญชี: ${
                          khaiwhanselectedbank.bankowner
                        }`
                      "
                    ></bank-number> -->
                  </div>

                  <div
                    :class="{ 'has-error': errors.has('paymentSlipImage') }"
                    class="mb-4"
                    v-if="
                      !shippingType ||
                      (shippingType && shippingType.type != 'cod_charge')
                    "
                  >
                    <h3 class="headline" :style="{ color: theme.color }">
                      {{ $t('Payment slip') }}
                    </h3>
                    <br />

                    <upload-file
                      name="paymentSlipImage"
                      v-validate="'required'"
                      :data-vv-as="$t('Payment Slip Image')"
                      v-model="paymentSlipImage"
                    ></upload-file>
                    <p
                      class="caption ma-2"
                      style="color: red"
                      v-show="errors.has('paymentSlipImage')"
                    >
                      {{ errors.first('paymentSlipImage') }}
                    </p>
                  </div>
                </div>

                <div class="text-xs-center">ต้องการรับสินค้าในช่วงเวลา</div>

                <v-layout wrap>
                  <v-flex xs12 sm8 class="px-1">
                    <v-dialog
                      ref="dialog"
                      v-model="showDatePicker"
                      :return-value.sync="pickupdate"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="pickupdate"
                          label="วันที่รับสินค้า"
                          :data-vv-as="'วันที่รับสินค้า'"
                          prepend-inner-icon="event"
                          readonly
                          name="pickupdate"
                          v-validate="'required'"
                          :error="errors.has('pickupdate') ? true : false"
                          :error-messages="
                            errors.has('pickupdate')
                              ? errors.first('pickupdate')
                              : ''
                          "
                          outline
                          :color="theme.color"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="pickupdate"
                        scrollable
                        :color="theme.color"
                        :min="mindate"
                        :max="maxdate"
                        :allowed-dates="allowedDates"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          flat
                          :color="theme.color"
                          @click="showDatePicker = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          flat
                          :color="theme.color"
                          @click="$refs.dialog.save(pickupdate)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs12 sm4 class="px-1">
                    <template v-if="chooseShippingType == 'delivery'">
                      <v-select
                        v-model="pickuptime"
                        outline
                        :color="theme.color"
                        label="ช่วงเวลารับสินค้า"
                        key="timerange"
                        data-vv-as="ช่วงเวลารับสินค้า"
                        v-validate="'required'"
                        :items="pickuptimelist"
                        name="pickuptime"
                        :error="errors.has('pickuptime') ? true : false"
                        :error-messages="
                          errors.has('pickuptime')
                            ? errors.first('pickuptime')
                            : ''
                        "
                      ></v-select>
                    </template>
                    <template v-else>
                      <v-select
                        v-model="pickuptime"
                        outline
                        :color="theme.color"
                        label="ช่วงเวลารับสินค้า"
                        key="timerange"
                        data-vv-as="ช่วงเวลารับสินค้า"
                        v-validate="'required'"
                        :items="
                          pickuplocation ==
                          'รับสินค้าที่ สาขา 1 ร้านเพียวไลท์ (รามอินทรา)'
                            ? pickuptimelist2
                            : pickuptimelist3
                        "
                        name="pickuptime"
                        :error="errors.has('pickuptime') ? true : false"
                        :error-messages="
                          errors.has('pickuptime')
                            ? errors.first('pickuptime')
                            : ''
                        "
                      ></v-select>
                    </template>
                  </v-flex>
                </v-layout>

                <div
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="$t('Remark')"
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('Remark')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-textarea>
                </div>
                <div>
                  <div
                    v-if="
                      pageProfile.fbpay_status ||
                      (pageProfile.gbprime_status && !isOoca)
                    "
                    style="padding-bottom: 25px"
                  >
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap class="mb-3">
                          <v-flex
                            :xs6="paymentList.length > 1"
                            :xs12="paymentList.length == 1"
                            class="px-1"
                            v-if="paymentList.includes('fbpay')"
                          >
                            <v-btn
                              :color="theme.color"
                              dark
                              block
                              small
                              @click="transferType = 'fbpay'"
                              :outline="transferType != 'fbpay'"
                            >
                              <v-icon small class="mr-2"
                                >mdi-facebook-messenger</v-icon
                              >
                              {{ $t('Mobile Banking') }}
                            </v-btn>
                            <div
                              class="text-xs-center"
                              :style="{ color: theme.color }"
                            >
                              <!-- (รวดเร็วกว่า) -->
                            </div>
                          </v-flex>
                          <v-flex
                            :xs6="paymentList.length > 1"
                            :xs12="paymentList.length == 1"
                            class="px-1"
                            v-if="paymentList.includes('gbprime')"
                          >
                            <v-btn
                              :color="theme.color"
                              dark
                              block
                              small
                              @click="transferType = 'qrcode'"
                              :outline="transferType != 'qrcode'"
                            >
                              <v-icon small class="mr-2">mdi-qrcode-scan</v-icon
                              >QR CODE
                            </v-btn>
                            <div
                              class="text-xs-center"
                              :style="{ color: theme.color }"
                            >
                              <!-- (รวดเร็วกว่า) -->
                            </div>
                          </v-flex>
                          <v-flex
                            :xs6="paymentList.length > 1"
                            :xs12="paymentList.length == 1"
                            class="px-1"
                            v-if="paymentList.includes('transfer')"
                          >
                            <v-btn
                              :color="theme.color"
                              dark
                              block
                              small
                              @click="transferType = 'transfer'"
                              :outline="transferType != 'transfer'"
                            >
                              <v-icon small class="mr-2"
                                >mdi-cash-multiple</v-icon
                              >
                              {{ $t('transfer') }}
                            </v-btn>
                          </v-flex>
                          <v-flex
                            :xs6="paymentList.length > 1"
                            :xs12="paymentList.length == 1"
                            class="px-1"
                            v-if="paymentList.includes('creditgbprime')"
                          >
                            <v-btn
                              :color="theme.color"
                              dark
                              small
                              block
                              @click="
                                transferType = 'creditgbprime'
                                setShippingDefault()
                              "
                              :outline="transferType != 'creditgbprime'"
                            >
                              <template>
                                <v-icon small class="mr-2"
                                  >mdi-credit-card</v-icon
                                >
                                {{ $t('Credit Cards') }}
                              </template>
                            </v-btn>
                          </v-flex>
                        </v-layout>

                        <template
                          v-if="['transfer', 'fbpay'].includes(transferType)"
                        >
                          <div v-if="['transfer'].includes(transferType)">
                            <div class="mb-4">
                              <template v-if="banktransferinfo_photo">
                                <img
                                  :src="banktransferinfo_photo"
                                  alt="bank transfer"
                                  style="
                                    border: 1px solid #eee;
                                    border-radius: 5px;
                                    margin-bottom: 15px;
                                    width: 100%;
                                  "
                                />
                              </template>
                              <template v-if="banktransferinfo">
                                <bank-number
                                  :text="banktransferinfo"
                                ></bank-number>
                              </template>
                            </div>

                            <div
                              :class="{
                                'has-error': errors.has('paymentSlipImage')
                              }"
                              class="mb-4"
                              v-if="
                                !shippingType ||
                                (shippingType &&
                                  shippingType.type != 'cod_charge')
                              "
                            >
                              <h3
                                class="headline"
                                :style="{ color: theme.color }"
                              >
                                {{ $t('Payment slip') }}
                              </h3>
                              <br />

                              <upload-file
                                name="paymentSlipImage"
                                v-validate="'required'"
                                :data-vv-as="$t('Payment Slip Image')"
                                v-model="paymentSlipImage"
                              ></upload-file>
                              <p
                                class="caption ma-2"
                                style="color: red"
                                v-show="errors.has('paymentSlipImage')"
                              >
                                {{ errors.first('paymentSlipImage') }}
                              </p>
                            </div>
                          </div>

                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <p
                            class="text-xs-center"
                            style="color: red"
                            v-if="isEmptyShoppingCart"
                          >
                            {{
                              $t(
                                'Not enough products in stock, please try to order again.'
                              )
                            }}.
                          </p>
                          <div
                            v-else-if="!ableToBuy"
                            style="color: red"
                            class="text-xs-center"
                          >
                            <div>
                              อยู่นอกพื้นที่การจัดส่ง กรุณาติดต่อแอดมิน
                              090-979-0389
                            </div>
                            <v-btn
                              href="tel:+660909790389"
                              :color="theme.color"
                              class="white--text"
                            >
                              ติดต่อแอดมิน 090-979-0389
                            </v-btn>
                          </div>
                          <div class="text-xs-center" v-else>
                            <v-btn
                              dark
                              :color="theme.color"
                              :disabled="loading || isEmptyShoppingCart"
                              @click="handleSubmit"
                              :loading="pageLoading"
                            >
                              <v-icon class="mr-2">mdi-cart-outline</v-icon>
                              {{ $t('Proceed Payment') }}
                            </v-btn>
                          </div>
                        </template>
                        <template
                          v-else-if="['creditgbprime'].includes(transferType)"
                        >
                          <div>
                            <v-card class="elevation-0">
                              <v-card-text>
                                <form
                                  ref="form-gbcredit"
                                  id="gbcredit-payment-form"
                                  method="POST"
                                >
                                  <div
                                    :class="{
                                      'has-error': errors.has('Cardholdername')
                                    }"
                                    class="mb-1"
                                  >
                                    <v-text-field
                                      name="Cardholdername"
                                      :data-vv-as="$t('Cardholder Name')"
                                      label="Cardholder Name"
                                      :color="theme.color"
                                      v-model="creditcard.name"
                                      maxlength="120"
                                      placeholder=" "
                                      v-validate="'required'"
                                      :error="
                                        errors.has('Cardholdername')
                                          ? true
                                          : false
                                      "
                                      :error-messages="
                                        errors.has('Cardholdername')
                                          ? errors.first('Cardholdername')
                                          : ''
                                      "
                                    ></v-text-field>
                                  </div>
                                  <div
                                    :class="{
                                      'has-error': errors.has('cardnumber')
                                    }"
                                    class="mb-1"
                                  >
                                    <v-text-field
                                      data-encrypt="cardnumber"
                                      name="cardnumber"
                                      v-themask="'#### #### #### #### ###'"
                                      label="Card Number"
                                      placeholder=" "
                                      v-validate="'required|credit_card'"
                                      :error="
                                        errors.has('cardnumber') ? true : false
                                      "
                                      :error-messages="
                                        errors.has('cardnumber')
                                          ? errors.first('cardnumber')
                                          : ''
                                      "
                                      :color="theme.color"
                                      v-model="creditcard.number"
                                    ></v-text-field>
                                  </div>
                                  <v-layout>
                                    <v-flex xs6 class="pr-1">
                                      <div
                                        class="form-control"
                                        :class="{
                                          'has-error':
                                            errors.has('month') ||
                                            errors.has('year')
                                        }"
                                      >
                                        <v-text-field
                                          label="Expire date"
                                          v-themask="'##/##'"
                                          :masked="true"
                                          :error="
                                            errors.has('month') ||
                                            errors.has('year')
                                          "
                                          :error-messages="
                                            errors.has('month')
                                              ? errors.first('month')
                                              : errors.has('year')
                                              ? errors.first('month')
                                              : ''
                                          "
                                          placeholder="MM/YY"
                                          :color="theme.color"
                                          @input="onChangeExpireDate"
                                          v-model="creditcard.validate"
                                        />

                                        <v-text-field
                                          data-encrypt="month"
                                          name="month"
                                          :data-vv-as="'Month'"
                                          style="width: 0; height: 0"
                                          v-validate="'required'"
                                          readonly
                                          class="pa-0"
                                          v-model="creditcard.expiremonth"
                                        />
                                        <v-text-field
                                          name="year"
                                          data-encrypt="year"
                                          class="pa-0"
                                          :data-vv-as="'Year'"
                                          v-validate="'required'"
                                          style="
                                            visibility: hidden;
                                            width: 0;
                                            height: 0;
                                          "
                                          readonly
                                          v-model="creditcard.expireyear"
                                        />
                                      </div>
                                    </v-flex>
                                    <v-flex xs6 class="pl-1">
                                      <div
                                        :class="{
                                          'has-error': errors.has('cvv')
                                        }"
                                      >
                                        <v-text-field
                                          label="CVV/CVV2"
                                          v-validate="'required'"
                                          :data-vv-as="'CVV/CVV2'"
                                          data-encrypt="cvv"
                                          name="cvv"
                                          v-themask="['###', '####']"
                                          placeholder=" "
                                          :color="theme.color"
                                          v-model="creditcard.cvv"
                                          :error="
                                            errors.has('cvv') ? true : false
                                          "
                                          :error-messages="
                                            errors.has('cvv')
                                              ? errors.first('cvv')
                                              : ''
                                          "
                                        />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <input
                                    type="hidden"
                                    v-model="orderid"
                                    name="orderid"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="amount"
                                    name="amount"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="facebookname"
                                    name="facebookname"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="pageid"
                                    name="pageid"
                                  />
                                </form>
                              </v-card-text>
                              <div class="pb-3 text-xs-center">
                                <img
                                  width="120px"
                                  src="@/assets/img/creditcardlogo.png"
                                />
                              </div>
                            </v-card>
                          </div>
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>

                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div
                              v-else-if="!ableToBuy"
                              style="color: red"
                              class="text-xs-center"
                            >
                              <div>
                                อยู่นอกพื้นที่การจัดส่ง กรุณาติดต่อแอดมิน
                                090-979-0389
                              </div>
                              <v-btn
                                href="tel:+660909790389"
                                :color="theme.color"
                                class="white--text"
                              >
                                ติดต่อแอดมิน 090-979-0389
                              </v-btn>
                            </div>

                            <div class="text-xs-center" v-else>
                              <v-btn
                                dark
                                :color="theme.color"
                                :disabled="loading || isCartOutOfStock"
                                @click="gbcreditSubmit"
                                :loading="pageLoading"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{ $t('Proceed Payment') }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <p
                            class="text-xs-center"
                            style="color: red"
                            v-if="isEmptyShoppingCart"
                          >
                            {{
                              $t(
                                'Not enough products in stock, please try to order again.'
                              )
                            }}.
                          </p>
                          <div
                            v-else-if="!ableToBuy"
                            style="color: red"
                            class="text-xs-center"
                          >
                            <div>
                              อยู่นอกพื้นที่การจัดส่ง กรุณาติดต่อแอดมิน
                              090-979-0389
                            </div>
                            <v-btn
                              href="tel:+660909790389"
                              :color="theme.color"
                              class="white--text"
                            >
                              ติดต่อแอดมิน 090-979-0389
                            </v-btn>
                          </div>

                          <div v-else class="text-xs-center">
                            <v-btn
                              dark
                              :color="theme.color"
                              :disabled="loading || isEmptyShoppingCart"
                              @click="qrHandleSubmit"
                              :loading="pageLoading || loadingQrcode"
                            >
                              <v-icon class="mr-2">mdi-cart-outline</v-icon>
                              {{ $t('Proceed Payment') }}
                            </v-btn>
                          </div>
                        </template>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div
                    v-if="
                      !(pageProfile.fbpay_status || pageProfile.gbprime_status)
                    "
                    class="text-xs-center"
                    style="padding-bottom: 25px"
                  >
                    <div style="padding-top: 15px; padding-bottom: 15px">
                      <a
                        href="javascript:void(0);"
                        @click="openModal()"
                        style="color: rgb(169, 169, 169)"
                      >
                        {{ $t('By clicking Proceed Payment, Ive read and') }}
                        <br />
                        {{ $t('agree to') }}
                        <span :style="{ color: theme.color }">
                          {{ $t('Terms & Condition & Refund Prolicy') }} </span
                        >.
                      </a>
                    </div>
                    <p
                      class="text-xs-center"
                      style="color: red"
                      v-if="isEmptyShoppingCart"
                    >
                      {{
                        $t(
                          'Not enough products in stock, please try to order again.'
                        )
                      }}.
                    </p>
                    <div
                      v-else-if="!ableToBuy"
                      style="color: red"
                      class="text-xs-center"
                    >
                      <div>
                        อยู่นอกพื้นที่การจัดส่ง กรุณาติดต่อแอดมิน 090-979-0389
                      </div>
                      <v-btn :color="theme.color" class="white--text">
                        ติดต่อแอดมิน
                      </v-btn>
                    </div>
                    <v-btn
                      dark
                      v-else
                      :color="theme.color"
                      :disabled="loading || isEmptyShoppingCart"
                      @click="handleSubmit"
                      :loading="pageLoading"
                    >
                      <v-icon class="mr-2">mdi-cart-outline</v-icon>
                      {{ $t('Proceed Payment') }}
                    </v-btn>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </div>
    </v-app>
    <Loading v-if="!pageLoading && loading"></Loading>
    <term-and-condition v-if="showTerm" @close="close()"></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <template v-if="gbcharge">
      <form
        ref="gbchargeform"
        name="form"
        :action="`${gbpath}/v1/tokens/3d_secured`"
        method="POST"
      >
        publicKey:
        <input type="text" name="publicKey" :value="gbpublickey" /><br />
        gbpReferenceNo:
        <input
          type="text"
          name="gbpReferenceNo"
          :value="gbcharge.gbpReferenceNo"
        />
      </form>
    </template>
  </div>
</template>

<script>
import MainTransfer from './MainTransfer'
import { mapGetters } from 'vuex'

import $ from 'jquery'
import config from '@/config'
import axios from 'axios'
import nl2br from 'vue-nl2br'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'
import Cover from '@/components/Cover.vue'
import UploadFile from '@/components/UploadFile.vue'
import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import CartItem from '@/components/payment/CartItem.vue'
import BankNumber from '@/components/BankNumber.vue'
import ShippingType from '@/components/ecommerce/ShippingType.vue'
import CartSummary from '@/components/ecommerce/CartSummary.vue'
import GmapAddress from '@/components/ecommerce/GmapAddress2.vue'
import { bearhousecalculateshippingprice } from '@/assets/js/BearHouse.js'
import moment from 'moment'
// import querystring from "querystring";
import numeral from 'numeral'

import { shippingprice as PurelifePostcode } from './PurelifePostcode.js'

const dict = {
  en: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'Wrong shipping address'
      }
    }
  },
  th: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      }
    }
  },
  la: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      }
    }
  }
}

export default {
  mixins: [MainTransfer],
  data() {
    return {
      loadingQrcode: false,
      showDatePicker: false,
      pickupdate: null,
      mindate: moment().add('1', 'days').format('YYYY-MM-DD'),
      maxdate: moment().add('15', 'days').format('YYYY-MM-DD'),
      timestamp: moment().format('x'),
      app: 'facebook',
      khaiwhandistance: null,
      lastordercoords: null,
      gmapvalue: null,
      pageid: null,
      userid: null,
      paiddate: null,
      paidtime: null,
      products: {},
      remark: '',
      transferType: '',
      khaiwhanshippingprice: 0,
      shippingprice: 0,

      additionalproduct_charge: 0,
      ems_charge: 0,
      normal_charge: 0,
      kerry_charge: 0,
      total: 0,
      totalincludediscount: 0,
      discount: 0,

      shippingType: undefined,

      loading: false,
      pageLoading: true,
      khaiwhanselectedbank: {
        bankname: '',
        banknum: '',
        bankowner: ''
      },
      isCompleted: false,
      isEmptyShoppingCart: false,

      shippingAddress: null,
      showAlert: false,
      showProduct: false,
      shippinglist: undefined,
      showQrCode: false,
      qrimage: '',
      intervalQrCode: null,
      timer: 300,
      isRequest: true,
      referenceNo: '',

      config: {
        color: config.color
      },
      placesinfo: '',
      sessiontoken: null,
      banktransferinfo: null,
      banktransferinfo_photo: null,
      mainBankTransferInfoPhoto: null,
      paymentSlipImage: null,
      branchlocation: '',

      showTerm: false,
      customerName: null,
      customerPhone: null,
      //   qrimage: "",
      showmap: false,
      pickuptime: null,
      pickuptimelist: ['10:30 - 12:30', '13:30 - 15:30', '16:00 - 18:00'],
      pickuptimelist2: ['08:00 - 18:00'],
      pickuptimelist3: ['10:30 - 15:00'],

      chooseShippingType: 'delivery',
      ableToShipping: false,
      pickuplocation: 'รับสินค้าที่ สาขา 1 ร้านเพียวไลท์ (รามอินทรา)',
      placesinfolabel: ''
    }
  },
  mounted: async function () {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)

    var format = 'hh:mm:ss'

    var time = moment(moment(), format),
      beforeTime = moment('17:00:00', format),
      afterTime = moment('23:59:59', format)

    if (time.isBetween(beforeTime, afterTime)) {
      this.mindate = moment().add('2', 'days').format('YYYY-MM-DD')
      this.maxdate = moment().add('16', 'days').format('YYYY-MM-DD')
    } else {
      this.mindate = moment().add('1', 'days').format('YYYY-MM-DD')
      this.maxdate = moment().add('15', 'days').format('YYYY-MM-DD')
    }

    vm.loading = true

    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid
    }

    if (vm.$route.query.pkey) {
      vm.omise_key = vm.$route.query.pkey
    }

    if (vm.$route.query.app) {
      vm.app = vm.$route.query.app
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken
    }
    vm.pageLoading = true

    vm.pageid = vm.pageProfile.pageid

    if (vm.pageProfile.fbpay_status) {
      vm.transferType = 'fbpay'
    } else if (vm.pageProfile.gbprime_status) {
      vm.transferType = 'qrcode'
    } else {
      vm.transferType = 'transfer'
    }

    document.title = vm.pageProfile.pagename
    vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)
    vm.pageLoading = false

    if (vm.userid) {
      try {
        let firstletterofuserid = vm.userid.charAt(0)
        if (firstletterofuserid && firstletterofuserid.toLowerCase() == 'u') {
          vm.app = 'line'
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
      // var response_lang = await vm.$store.dispatch("getUserShopLang", {
      //   pageid: vm.pageProfile.pageid,
      //   userid: vm.userid,
      // });
      // if (response_lang) {
      //   vm.$store.dispatch("setLang", response_lang.usershoplang);
      // }
      vm.$store.dispatch('setLang', vm.pageProfile.shoplang)

      vm.getUserDetail().then(function (data) {
        vm.customerName = data.name
        vm.customerPhone = data.phone
        if (data.address) {
          // eslint-disable-next-line no-useless-escape
          var gmapregex =
            /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
          var address = data.address.replace(gmapregex, '').replace('\n', '')
          vm.shippingAddress = address
        }
      })

      // var data = {
      //   userid: vm.userid,
      //   pageid: vm.pageProfile.pageid,
      //   lang: vm.currentLang
      // };
      // vm.$store.dispatch("setLang", vm.currentLang);
      // vm.$store.dispatch("updatePageProfile", data);
    }
    // vm.$store.dispatch("getWholeSaleStatus", vm.pageProfile.pageid).then(function() {
    if (vm.pageProfile.wholesale_status === true) {
      vm.$store.dispatch('getWholeSale', vm.pageProfile.pageid)
    }
    // });
    await vm.getProducts()
    await vm.getUserCart(this.pageProfile.shippinglist)
    await vm.getbranchlocation()
    // await vm.getTransferDetail();
    vm.loading = false
  },
  components: {
    SyncLoader,
    Loading,
    Modal,
    Cover,
    MerchantDetail,
    nl2br,
    UploadFile,
    TermAndCondition,
    CartItem,
    BankNumber,
    ShippingType,
    CartSummary,
    GmapAddress
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),
    bearhouseshippingprice() {
      var zipcode = ''
      if (
        this.shippingAddress &&
        this.shippingAddress.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/g)
      ) {
        zipcode = this.shippingAddress
          .match(/([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/g)[0]
          .trim()
      }
      return bearhousecalculateshippingprice(zipcode, this.cart.length)
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    isOoca() {
      return (
        this.pageProfile &&
        ['100935418246290', '142088386194745'].includes(this.pageProfile.pageid)
      )
    },
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    isGaiGao() {
      return this.pageProfile && this.pageProfile.type == 'gaigao'
    },
    totalPrice: function () {
      return (
        this.totalincludediscount +
        (this.customshippingprice || 0) +
        (this.additionalproduct_charge || 0)
      )
    },
    // isCartOutOfStock: function() {
    //   return (
    //     this.cart.filter(function(el) {
    //       if (el.optionDetail == null) {
    //         return true;
    //       }
    //       if (parseInt(el.optionDetail[2]) < el.quantity) {
    //         return true;
    //       }
    //       return false;
    //     }).length > 0
    //   );
    // },
    ableToBuy() {
      if (this.chooseShippingType == 'delivery') {
        return this.ableToShipping
      } else {
        return true
      }
    },
    customshippingprice() {
      if (this.chooseShippingType == 'delivery') {
        return this.shippingprice
      } else {
        return 0
      }
    }
  },
  methods: {
    async closeQrCode() {
      this.showQrCode = false
    },
    allowedDates(val) {
      const betweenSongkran = moment(val).isBetween('2022-04-13', '2022-04-21')
      if (betweenSongkran) {
        return false
      }
      let holiday = ['2022-07-13', '2022-07-14', '2022-07-30']
      let isHoliday = holiday.some((el) => {
        return moment(val).isSame(el)
      })
      if (isHoliday) {
        return false
      }
      if (
        this.pickuplocation &&
        this.pickuplocation.includes('สาขา 2 ร้านนมเพียว') &&
        this.chooseShippingType == 'pickup'
      ) {
        return (
          moment(val).weekday() == 1 ||
          moment(val).weekday() == 3 ||
          moment(val).weekday() == 5
        )
      }
      return true
    },
    async contactAdmin() {
      if (this.$liff.isInClient()) {
        // eslint-disable-next-line no-undef
        await this.$liff.sendMessages([
          {
            type: 'text',
            text: 'ติดต่อแอดมิน'
          }
        ])
        // eslint-disable-next-line no-undef
        await this.$liff.closeWindow()
      } else {
        window.location.href =
          'https://m.me/' + this.pageid + '?ref=contactadmin'
        // eslint-disable-next-line no-undef
        MessengerExtensions.requestCloseBrowser(
          function success() {},
          function error() {
            window.close()
          }
        )
      }
    },
    getbranchlocation() {
      var vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'branchlocation?pageid=' +
              this.pageid
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              vm.branchlocation = response.data.branchlocation
              let externalScript = document.createElement('script')
              externalScript.setAttribute(
                'src',
                `https://maps.googleapis.com/maps/api/js?key=${response.data.googlekey}&language=th&libraries=places`
              )
              externalScript.async = true
              externalScript.defer = true
              externalScript.onload = () => {
                vm.showmap = true
                resolve()
              }
              document.head.appendChild(externalScript)
              // resolve();
            }
          })
      })
    },
    calCustomShippingPrice(distance_km, totalprice) {
      //   var ceiling_distance_km = Math.ceil(distance_km);
      try {
        var ceiling_distance_km = 0
        var decimal = parseFloat((distance_km % 1).toFixed(1))
        distance_km = Math.floor(distance_km)
        if (decimal > 0.4) distance_km += 1
        ceiling_distance_km += distance_km
      } catch (error) {
        console.error(error)
        return false
      }

      // 0-3 km ฟรีค่าส่ง
      // 3-5 km ค่าส่ง 10 บาท
      // 5-8 km ค่าส่ง 20 บาท
      // 8-20 บาท ค่าส่ง 50 บาท
      // 20-30 km ค่าส่ง 100 บาท
      // 30-50 km ค่าส่ง 150 บาท

      var price = 0
      if (totalprice < 200 || ceiling_distance_km > 50) {
        return false
      } else {
        var boxset = 0
        var drinkset = 0
        this.cart.map((cart) => {
          if ([11020, 11021, 11022].includes(cart.categoryid)) {
            boxset += parseInt(cart.quantity)
          }

          if ([11023].includes(cart.categoryid)) {
            drinkset += parseInt(cart.quantity)
          }
        })

        if (ceiling_distance_km > 30) {
          if (boxset >= 15) {
            price = 100
          } else {
            price = 150
          }
        } else if (ceiling_distance_km > 20) {
          price = 100
        } else if (ceiling_distance_km > 8) {
          price = 50
        } else if (ceiling_distance_km > 5) {
          price = 20
        } else if (ceiling_distance_km > 3) {
          price = 10
        } else {
          price = 0
        }

        if (ceiling_distance_km <= 30 && boxset >= 15) {
          price = 0
        }
        if (ceiling_distance_km <= 30 && drinkset >= 60) {
          price = 0
        }
      }

      //   console.log(price);
      return price
      //   if (totalprice >= 200) {
      //     var chargeprice = 0;
      //   } else {
      //     var chargeprice = 20;
      //   }
      //   distance_km -= 3;
      //   if (distance_km > 0) {
      //     var decimal = parseFloat((distance_km % 1).toFixed(1));
      //     distance_km = Math.floor(distance_km);
      //     if (decimal > 0.4) distance_km += 1;
      //     chargeprice += distance_km * 10;
      //   }
      //   return chargeprice;
    },
    gmapLocation() {
      var vm = this
      var locations = []
      var nearestlocation
      var stringlatlng =
        this.gmapvalue ||
        this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      // eslint-disable-next-line no-undef
      var service = new google.maps.DistanceMatrixService()
      var origins = vm.branchlocation.map((el) => el.lat_long)

      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH',
          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'optimistic'
          }
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          var bodyjson = response
          for (var i = 0; i < bodyjson.rows.length; i++) {
            var row = bodyjson.rows[i].elements[0].distance

            try {
              locations.push({
                name: vm.branchlocation[i].name,
                distance: parseFloat((row.value / 1000).toFixed(2)),
                pictureurl: vm.branchlocation[i].pictureurl
              })
            } catch (error) {
              console.error(error)
            }
          }

          locations.sort((a, b) => {
            var x = a.distance
            var y = b.distance
            return x < y ? -1 : x > y ? 1 : 0
          })

          nearestlocation = locations[0]
          vm.shippingAddress = response.destinationAddresses[0]
          vm.placesinfo = response.destinationAddresses[0]
          vm.khaiwhandistance = nearestlocation
          var shippingprice = vm.calCustomShippingPrice(
            nearestlocation.distance,
            vm.totalincludediscount
          )
          var inBKK = false
          try {
            var postcode = vm.shippingAddress.match(/\d{5}/)
            if (postcode) {
              inBKK = PurelifePostcode(postcode[0])
            }
          } catch (error) {
            //
          }

          vm.ableToShipping = shippingprice !== false && inBKK !== false

          vm.shippingprice = vm.ableToShipping ? shippingprice : 0

          if (vm.branchlocation && vm.branchlocation.length > 0) {
            vm.banktransferinfo_photo = nearestlocation.pictureurl
          } else {
            vm.banktransferinfo_photo = vm.mainBankTransferInfoPhoto
          }

          vm.placesinfolabel =
            vm.placesinfo +
            ` (${vm.khaiwhandistance ? vm.khaiwhandistance.distance : 0} Km) ${
              shippingprice === false
                ? `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: red"> ไม่สามารถจัดส่งได้</div>`
                : `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: green">ค่าส่ง ${shippingprice} บาท</div>`
            }`
          //   vm.khaiwhanselectedbank = vm.khaiwhanbank.find((el) => el.ref == nearestlocation.name);
        } else {
          // 400
        }
      }
    },
    async checkOrderStatus() {
      //   var total = numeral(0.01).format("0.00");
      var total = numeral(this.totalPrice).format('0.00')
      var response = await axios.get(
        config.getConfig('serverUrl') +
          `gbcompletedwithrefnoverify?referenceNo=${this.referenceNo}&pageid=${this.pageid}&userid=${this.userid}&amount=${total}`
      )
      return response
    },
    requestQrCode() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = new FormData()
        var total = numeral(vm.totalPrice).format('0.00')
        // var total = numeral(0.01).format("0.00");
        vm.referenceNo = moment().format('x')

        data.append(
          'token',
          vm.pageProfile.gbprime_token
          // "PUD9omECXQTwqePYfQzTS+S+lExcJJVNe3Ov0G2swnmSLml8MW3Ws6AKuvavsm5ydRzYSXuTFhyW1Q52EqXQUATUTsI+i1yCX7HDupxf7UEt3FBpQIKtTpo2bf0GetHO63MLQuHRsGk5cCe3H/Rw+NyC/7+HkSScuRlx5ikPosSJ9aeG"
        )
        data.append('amount', total)
        data.append('referenceNo', vm.referenceNo)
        data.append('detail', '-')
        data.append('customerName', vm.customerName)
        data.append(
          'backgroundUrl',
          `https://zwizai.herokuapp.com/gbcompletedcartwithrefno?referenceNo=${vm.referenceNo}&amount=${total}&userid=${vm.userid}&pageid=${vm.pageid}`
        )

        var xhr = new XMLHttpRequest()
        // xhr.withCredentials = true;

        xhr.addEventListener('readystatechange', function () {
          if (this.readyState === 4) {
            if (this.status == 200) {
              var arrayBuffer = this.response // Note: not oReq.responseText
              if (arrayBuffer) {
                resolve(new Uint8Array(arrayBuffer))
              } else {
                reject()
              }
              //
            } else {
              reject()
            }
          }
        })

        xhr.open('POST', 'https://api.gbprimepay.com/gbp/gateway/qrcode')
        xhr.responseType = 'arraybuffer'
        // xhr.setRequestHeader("Content-Type", "application/json");

        xhr.send(data)
      })
    },
    async submitOrder() {
      if (this.isEmptyShoppingCart) {
        return false
      }

      var total = this.total + this.additionalproduct_charge
      if (this.shippingType) {
        total += this.shippingType.value
      }
      if (this.chooseShippingType == 'pickup') {
        this.shippingAddress = this.pickuplocation
      }
      let data = {
        amount: this.totalPrice.toFixed(2).toString().replace('.', ''),
        pageid: this.pageid,
        userid: this.userid,
        app: this.app,
        name: this.customerName,
        address: this.shippingAddress,
        phone: this.customerPhone,
        nameaddress:
          this.customerName +
          ' , ' +
          this.shippingAddress +
          ' , ' +
          this.customerPhone,
        shippingtype: this.shippingType ? this.shippingType.type : null,
        note: this.paymentSlipImage,
        remark:
          this.remark +
          ' รับสินค้าวันที่ ' +
          this.pickupdate +
          ' เวลา ' +
          this.pickuptime,
        payment: this.transferType == 'qrcode' ? 'qrcode' : null,
        shippingcharge: (
          (this.shippingType ? this.shippingType.value : 0) +
          this.additionalproduct_charge
        )
          .toFixed(2)
          .toString()
          .replace('.', ''),
        total: total.toFixed(2).toString().replace('.', '')
      }
      if (this.transferType == 'qrcode') {
        data.paiddate = moment()
        data.transactionid = this.referenceNo
      } else {
        data.paiddate = moment(`${this.paiddate} ${this.paidtime}`)
      }
      data.cart_ids = this.$store.state.cart_ids || []
      let url = config.getConfig('serverUrl') + 'banktransfernotify'
      if (this.sessiontoken != null || this.sessiontoken != '') {
        url += '?sessiontoken=' + this.sessiontoken
      }
      if (this.$route.query.from) {
        data.from = this.$route.query.from
      } else {
        try {
          var device = this.$liff.getOS()
          var version = this.$liff.getVersion()
          await this.$liff.ready

          if (
            this.userid.indexOf('__') != -1 &&
            device &&
            version &&
            !this.$liff.isInClient()
          ) {
            data.from = 'livechat'
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error)
        }
      }

      try {
        var response = await axios.post(url, data)

        // JSON responses are automatically parsed.
        response = response.data
        if (response.responsecode == 200) {
          this.isCompleted = true
          await this.$store.dispatch('deleteAllItemsInCart')
          // eslint-disable-next-line
          if (this.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            await this.$liff.sendMessages([
              {
                type: 'text',
                text: 'Order: ' + response.orderid
              }
            ])
            // eslint-disable-next-line no-undef
            await this.$liff.closeWindow()
          } else {
            // eslint-disable-next-line no-undef
            MessengerExtensions.requestCloseBrowser(
              function success() {},
              function error() {
                window.close()
              }
            )
          }
        } else if (response.responsecode == 201) {
          this.isCompleted = true
          await this.$store.dispatch('deleteAllItemsInCart')
          let url = '/ecommerce/' + this.pagename
          if (this.userid && this.userid != null && this.userid != '') {
            url += '?userid=' + this.userid
          }
          this.$router.push({ path: url })
        } else {
          await this.$swal({
            title: this.$t('Error'),
            text: this.$t('Something went wrong. Please try it again.'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        this.loading = false
        await this.$swal({
          title: this.$t('Error'),
          text: this.$t('Something went wrong. Please try it again.'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
      }
    },
    async getQrCode2() {
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        throw 400
      }

      try {
        this.loadingQrcode = true
        let photo = await this.gbcreaterefnofromcart()
        var response = await this.requestQrCode2(photo)
        var binary = response.reduce(
          (data, b) => (data += String.fromCharCode(b)),
          ''
        )
        this.qrimage = 'data:image/jpeg;base64,' + btoa(binary)
      } catch (error) {
        throw error
      }
      this.loadingQrcode = false
    },
    async gbcreaterefnofromcart() {
      try {
        var data = { ...this.formatOrderRequest(), ...this.extraOrderRequest() }

        let detail = []
        this.cart.map((el) => {
          detail.push(
            `${el.name}${el.option ? ` (${el.option})` : ''} x ${el.quantity}`
          )
        })

        let stringdetail = detail.join(',')
        if (stringdetail.length < 250) {
          stringdetail.slice(0, 250)
        }

        data.detail = stringdetail
        data.note = this.paymentSlipImage
        if (this.$route.query.from) {
          data.from = this.$route.query.from
        } else {
          try {
            var device = this.$liff.getOS()
            var version = this.$liff.getVersion()
            await this.$liff.ready

            if (
              this.userid.indexOf('__') != -1 &&
              device &&
              version &&
              !this.$liff.isInClient()
            ) {
              data.from = 'livechat'
            }
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }

        let response = await axios.post(
          config.getConfig('serverUrl') + 'gbcreaterefnofromcart',
          data,
          {
            params: {},
            headers: { AUTHORIZATION: 'Bearer xxx xxx' },
            responseType: 'arraybuffer'
          }
        )
        if (response.status == 200) {
          // console.log(response.data);
          return response.data
        } else {
          throw 400
        }
      } catch (error) {
        throw error
      }
    },
    formatOrderRequest() {
      var total = this.total + this.customshippingprice
      if (this.shippingType) {
        total += this.shippingType.value
      }
      var payment
      if (this.transferType) {
        payment = this.transferType
      } else {
        payment = null
      }
      var note = this.paymentSlipImage

      this.shippingAddress

      var combine_address = ''
      combine_address = this.shippingAddress.replace(/,/g, '')
      if (
        this.shippingAddress2 &&
        this.shippingAddress2.sub_district &&
        this.shippingAddress2.district &&
        this.shippingAddress2.province &&
        this.shippingAddress2.zipcode
      ) {
        var inBangkok = this.shippingAddress2.province == 'กรุงเทพมหานคร'
        combine_address =
          combine_address +
          ' , ' +
          [
            (inBangkok ? 'แขวง' : 'ตำบล') +
              this.shippingAddress2.sub_district.replace(/,/g, ''),
            (inBangkok ? 'เขต' : 'อำเภอ') +
              this.shippingAddress2.district.replace(/,/g, ''),
            'จังหวัด' + this.shippingAddress2.province.replace(/,/g, ''),
            this.shippingAddress2.zipcode.replace(/,/g, '')
          ].join(' , ')
      }

      let data = {
        amount: this.totalPrice.toFixed(2).toString().replace('.', ''),
        pageid: this.pageid,
        userid: this.userid,
        app: this.app,
        name: this.customerName,
        address: combine_address,
        phone: this.customerPhone,
        payment: payment,
        nameaddress:
          this.customerName.replace(/,/g, '') +
          ' , ' +
          combine_address +
          ' , ' +
          this.customerPhone.replace(/,/g, ''),
        shippingtype: this.shippingType ? this.shippingType.type : null,
        note: note,
        remark:
          this.pageProfile.type == 'monobo'
            ? this.remark + ';;' + this.bankname
            : this.remark,
        shippingcharge: (this.shippingType ? this.shippingType.value : 0)
          .toFixed(2)
          .toString()
          .replace('.', ''),
        total: total.toFixed(2).toString().replace('.', '')
      }

      if (this.sessiontoken != null || this.sessiontoken != '') {
        data.sessiontoken = this.sessiontoken
      }
      return data
    },
    extraOrderRequest() {
      var data = []
      // purelife customize start
      data.remark =
        this.remark +
        ' รับสินค้าวันที่ ' +
        this.pickupdate +
        ' เวลา ' +
        this.pickuptime
      // eslint-disable-next-line no-useless-escape
      var gmapregex =
        /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
      var shippingAddress
      if (this.chooseShippingType == 'pickup') {
        this.shippingAddress = this.pickuplocation
        shippingAddress = this.pickuplocation
      } else {
        if (this.shippingAddress) {
          if (gmapregex.test(this.shippingAddress)) {
            this.shippingAddress = this.shippingAddress
              .replace(gmapregex, '')
              .replace('\n', '')
          }
          shippingAddress =
            this.shippingAddress +
            '\nhttps://www.google.com/maps?q=' +
            this.gmapvalue.lat.toString() +
            ',' +
            this.gmapvalue.lng.toString()
        }
      }
      data.nameaddress =
        this.customerName + ' , ' + shippingAddress + ' , ' + this.customerPhone
      data.shippingtype = this.khaiwhandistance.name
      data.shippingcharge = this.customshippingprice
        .toFixed(2)
        .toString()
        .replace('.', '')
      // purelife customize end

      return data
    },
    requestQrCode2(photo) {
      // var vm = this;
      return new Promise((resolve, reject) => {
        if (photo) {
          // var photobyte = vm.getByte(photo);
          resolve(new Uint8Array(photo))
        } else {
          reject()
        }
      })
    },
    async gbcreditSubmit() {
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      if (this.isEmptyShoppingCart) {
        return false
      }
      this.loading = true
      var response = await this.getGBCreditToken()

      if (response.status == 200 && response.data.resultCode == '00') {
        var data = { ...this.formatOrderRequest(), ...this.extraOrderRequest() }
        data.creditcardtoken = response.data.card.token
        var order_response = await this.banktransfernotify(data)
        if (
          order_response.status == 200 &&
          order_response.data.responsecode == 200
        ) {
          this.gbcharge = {
            gbpReferenceNo: order_response.data.transactionid
          }
          await this.$nextTick()
          this.$refs.gbchargeform.submit()
        }
      }

      this.loading = false
    },
    getUserDetail: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'lastorderaddress?pageid=' +
              vm.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (response.data) {
                var gmapregex =
                  /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
                if (gmapregex.test(response.data.address)) {
                  var coords = response.data.address.match(gmapregex)[0]
                  coords = coords.split('@')[1].split(',')
                  vm.lastordercoords = { lat: coords[0], lng: coords[1] }
                }
                resolve(response.data)
              } else {
                reject()
              }
            } else {
              reject()
              // console.log(response);
            }
          })
      })
    },
    openModal: function () {
      this.showTerm = true
      let vm = this
      window.location.hash = '#modal-open'
      window.onpopstate = function () {
        if (location.hash == '#modal-open') {
          //   console.log("test");
        } else {
          vm.showTerm = false
        }
      }
    },
    close: function () {
      var vm = this
      if (window.history.length == 0) {
        vm.showTerm = false
      } else {
        window.history.back()
      }
    },
    getTransferDetail: async function () {
      let vm = this
      var response = await axios.get(
        config.getConfig('serverUrl') + 'banktransferinfo?pageid=' + vm.pageid
      )
      // JSON responses are automatically parsed.
      response = response.data
      if (response.responsecode == 200) {
        vm.banktransferinfo = response.banktransferinfo
        vm.banktransferinfo_photo = response.banktransferinfo_photo
        vm.mainBankTransferInfoPhoto = response.banktransferinfo_photo
      } else {
        //
      }
    },
    async qrHandleSubmit() {
      try {
        await this.getQrCode2()
        this.showQrCode = true
      } catch (error) {
        // console.log(error);
      }
    },
    handleSubmit: function () {
      let vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.isEmptyShoppingCart) {
          return false
        }
        vm.loading = true
        var data = { ...vm.formatOrderRequest(), ...vm.extraOrderRequest() }
        data.cart_ids = this.$store.state.cart_ids || []
        let url = config.getConfig('serverUrl') + 'banktransfernotify'
        if (vm.sessiontoken != null || vm.sessiontoken != '') {
          url += '?sessiontoken=' + vm.sessiontoken
        }
        if (vm.$route.query.from) {
          data.from = vm.$route.query.from
        } else {
          try {
            var device = vm.$liff.getOS()
            var version = vm.$liff.getVersion()
            vm.$liff.ready.then(() => {
              if (
                vm.userid.indexOf('__') != -1 &&
                device &&
                version &&
                !vm.$liff.isInClient()
              ) {
                data.from = 'livechat'
              }
            })
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }
        axios
          .post(url, data)
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              // eslint-disable-next-line
              if (vm.$liff.isInClient()) {
                // eslint-disable-next-line no-undef
                vm.$liff
                  .sendMessages([
                    {
                      type: 'text',
                      text: 'Order: ' + response.orderid
                    }
                  ])
                  .then(() => {})
                // eslint-disable-next-line no-undef
                vm.$liff.closeWindow()
              } else {
                // eslint-disable-next-line no-undef
                MessengerExtensions.requestCloseBrowser(
                  function success() {},
                  function error() {
                    window.close()
                  }
                )
              }
            } else if (response.responsecode == 400) {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t(response.reason),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            } else if (response.responsecode == 201) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              let url = '/ecommerce/' + vm.pagename
              if (vm.userid && vm.userid != null && vm.userid != '') {
                url += '?userid=' + vm.userid
              }
              vm.$router.push({ path: url })
            } else {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again.'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            }
            vm.loading = false
          })
          .catch(() => {
            vm.loading = false
            vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              reverseButtons: true
            })
          })
      })
    },

    // getUserCart: function() {
    //   let vm = this;
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get(
    //         config.getConfig("serverUrl") + "usercart?pageid=" + vm.pageid + "&userid=" + vm.userid
    //       )
    //       .then((response) => {
    //         // JSON responses are automatically parsed.
    //         response = response.data;
    //         if (response.responsecode == 200) {
    //           // vm.$store.dispatch('setCart',response.cartarray)

    //           vm.banktransferinfo = response.banktransferinfo;
    //           vm.banktransferinfo_photo = response.banktransferinfo_photo;
    //           if (response.cartarray) {
    //             if (response.cartarray.length == 0) {
    //               vm.isEmptyShoppingCart = true;
    //             }
    //             var product_id_list = [];
    //             var products = [];

    //             $.each(response.cartarray, function(index, val) {
    //               product_id_list.push(val.productid);

    //               if (vm.products[val.productid]) {
    //                 var stock = vm.products[val.productid].productstock;
    //                 var option = stock.find(function(el) {
    //                   return el[1] == val.option;
    //                 });
    //               }
    //               products.push({
    //                 photourl: val.photourl,
    //                 quantity: val.quantity,
    //                 name: val.name,
    //                 option: val.option,
    //                 id: val.productid,
    //                 price: parseFloat(val.price),
    //                 discountprice: parseFloat(val.discountprice),
    //                 optionDetail: option,
    //                 categoryid: val.categoryid,
    //                 cart_remark: val.cart_remark,
    //               });
    //             });

    //             if (products.length > 0) {
    //               let url =
    //                 config.getConfig("serverUrl") +
    //                 "productbundle?productid=" +
    //                 product_id_list.join(",");
    //               axios.get(url).then((response) => {
    //                 response = response.data;
    //                 if (response.responsecode == 200) {
    //                   var allproductbundle = response.productbundlelist;
    //                   $.each(products, function(index, product) {
    //                     var p = product;
    //                     var bundles = [];
    //                     $.each(allproductbundle, function(bindex, bundle) {
    //                       if (bundle.productid == p.id) {
    //                         bundles.push(bundle);
    //                       }
    //                     });

    //                     p.productbundle = bundles;

    //                     vm.$store.dispatch("addToCart", p);
    //                   });
    //                 }
    //               });
    //             }

    //             vm.additionalproduct_charge = parseFloat(response.additionalproduct_charge);
    //             vm.ems_charge = parseFloat(response.ems_charge);
    //             vm.normal_charge = parseFloat(response.normal_charge);
    //             vm.kerry_charge = parseFloat(response.kerry_charge);
    //             vm.total = parseFloat(response.total);
    //             vm.totalincludediscount = parseFloat(response.totalincludediscount);
    //             vm.discount = parseFloat(response.discount);

    //             vm.shippinglist = response.shippinglist;
    //           }
    //           resolve();
    //         } else {
    //           // console.log(response);
    //           reject();
    //         }
    //       });
    //   });
    // },
    goToShop: function () {
      let vm = this
      let url = '/ecommerce/' + vm.pagename
      if (vm.userid && vm.userid != null && vm.userid != '') {
        url += '?userid=' + vm.userid
        if (
          vm.sessiontoken &&
          vm.sessiontoken != null &&
          vm.sessiontoken != ''
        ) {
          url += '&sessiontoken=' + vm.sessiontoken
        }
      }
      vm.$router.push({ path: url })
    },
    getProducts: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }
        axios
          .get(config.getConfig('serverUrl') + 'products', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.products = {}
              $.each(response.productlist, function (index, val) {
                response.productlist[index].price = parseFloat(
                  response.productlist[index].price
                )
                response.productlist[index].discountprice = parseFloat(
                  response.productlist[index].discountprice
                )
                response.productlist[index].isOutOfStock = false

                if (response.productlist[index].productstock.length > 0) {
                  var haveStock = false
                  $.each(val.productstock, function (pindex, pval) {
                    if (
                      parseInt(
                        response.productlist[index].productstock[pindex][2]
                      ) > 0
                    ) {
                      haveStock = true
                    }

                    var price = 0
                    var discount = 0

                    if (pval[3] == null && pval[4] == null) {
                      price = parseFloat(val.price)
                      discount = parseFloat(val.discountprice)
                    } else {
                      if (pval[3] == null) {
                        price = parseFloat(val.price)
                      } else {
                        price = parseFloat(
                          response.productlist[index].productstock[pindex][3]
                        )
                      }

                      if (pval[4] == null) {
                        discount =
                          response.productlist[index].productstock[pindex][3]
                      } else {
                        discount = parseFloat(
                          response.productlist[index].productstock[pindex][4]
                        )
                      }
                    }

                    response.productlist[index].productstock[pindex][3] = price

                    response.productlist[index].productstock[pindex][4] =
                      discount
                  })

                  if (!haveStock) {
                    response.productlist[index].isOutOfStock = true
                  }
                } else {
                  response.productlist[index].isOutOfStock = true
                }
                if (val) {
                  vm.products[val.id] = val
                }
              })

              resolve()
            } else {
              // console.log(response);
              reject()
            }
          })
      })
    }
  }
}
</script>
